import Vue from "vue";
import Vuex from "vuex";
import Alert from "./modules/alert";
import Authentication from "./modules/authentication";
import Document from "./modules/document";
import GeneratePdf from "./modules/generatePdf";
import Loading from "./modules/loading";
import Merchant from "./modules/merchant";
import Payment from "./modules/payment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Merchant,
    Authentication,
    Document,
    Alert,
    Loading,
    GeneratePdf,
    Payment
  },
  strict: true,
});
